/** Sektör anahtarları — API / DB ile aynı (Pin.Sector) */
export const FACILITY_SECTOR_LABELS: Record<string, string> = {
    energy_utilities: 'Enerji ve kamu hizmetleri',
    finance_banking: 'Finans ve bankacılık',
    hospitality_tourism_events: 'Konaklama, turizm ve etkinlikler',
    industrial_manufacturing: 'Sanayi ve üretim',
    other: 'Diğer',
    religious_cultural: 'Dini ve kültürel',
    residential_vip: 'Konut (VIP)',
    retail_commercial: 'Perakende ve ticari',
    transportation_logistics: 'Ulaşım ve lojistik',
};

export const FACILITY_SECTOR_KEYS = Object.keys(FACILITY_SECTOR_LABELS) as (keyof typeof FACILITY_SECTOR_LABELS)[];

/**
 * Liste ve raporlarda gösterim: yeni kayıtlar anahtar + isteğe bağlı SectorCustom; eski kayıtlar serbest metin.
 */
export function formatSectorDisplay(
    sector: string | null | undefined,
    sectorCustom?: string | null | undefined
): string {
    if (!sector?.trim()) return '';
    const key = sector.trim();
    if (key === 'other' && sectorCustom?.trim()) return sectorCustom.trim();
    return FACILITY_SECTOR_LABELS[key] ?? key;
}
